export const config = {
    defaultThreshold: 150,
    defaultDragThreshold: 15,
    defaultMaxRotation: 20,
    defaultStack: 0,
    defaultStackOffset: 20,
    defaultStackDirection: 'bottom',
    defaultTransitionName: 'card-transition',
}